import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import Tabs from "./Tabs";
import Chart from "./Chart";
import TopOptions from "./TopOptions";
import Grid2 from "@mui/material/Unstable_Grid2";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import NotFound from "../../../components/notfound/NotFound";
import { useState } from "react";
import OptionValueChart from "./OptionValueChart";

const DashboardOptions = () => {
  const [currentTab, setCurrentTab] = useState("option-value");

  const { data = [], isLoading } = useSWR(
    currentTab === "option-value"
      ? "/dashboard/option-value"
      : currentTab === "put-to-call"
        ? "/dashboard/put-to-call"
        : currentTab === "option-to-market"
          ? "/dashboard/option-to-market"
          : null,
    fetchData,
    {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000,
    }
  );
  return (
    <Card sx={{ padding: 0, boxShadow: "none" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "16px", lg: "18px" },
            fontWeight: 700,
          }}
        >
          آپشن ها
        </Typography>
        <Grid2 container spacing={2}>
          <Grid2 xs={12} lg={6}>
            <Box
              sx={{
                height: 350,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Tabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
              {isLoading ?
                <Skeleton height={"100%"} variant="rounded" />
                : !data || data.length === 0 ? (
                  <Box sx={{ margin: "auto", height: "100%" }}>
                    <NotFound />
                  </Box>
                ) : (
                  currentTab === "option-value" ?
                    <OptionValueChart chartData={data} />
                    : <Chart chartData={data} />
                )}
            </Box>
          </Grid2>
          <Grid2 xs={12} lg={6}>
            <TopOptions />
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
};

export default DashboardOptions;
